import React from "react";
import { WeCockpitLogo } from "../components/branding/WeCockpitLogo";

/**
 * Page de prévisualisation du logo WECOCKPIT — usage interne, accessible via /brand-preview
 * Affiche toutes les variantes, tons et contextes pour validation rapide.
 */
export default function BrandPreviewPage() {
  return (
    <div className="min-h-screen bg-slate-50 p-8 space-y-10" data-testid="brand-preview-page">
      <h1 className="text-2xl font-bold">WECOCKPIT — Brand Preview</h1>

      <section className="space-y-4">
        <h2 className="text-sm font-bold uppercase tracking-wider text-slate-500">Lockup horizontal — fond clair</h2>
        <div className="bg-white p-6 rounded-xl border flex flex-wrap gap-8 items-center">
          <WeCockpitLogo size={28} tone="dark"/>
          <WeCockpitLogo size={40} tone="dark"/>
          <WeCockpitLogo size={56} tone="dark"/>
          <WeCockpitLogo size={40} tone="dark" withTagline/>
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-sm font-bold uppercase tracking-wider text-slate-500">Lockup horizontal — fond sombre</h2>
        <div className="bg-[#0F2744] p-6 rounded-xl flex flex-wrap gap-8 items-center">
          <WeCockpitLogo size={28} tone="light"/>
          <WeCockpitLogo size={40} tone="light"/>
          <WeCockpitLogo size={56} tone="light"/>
          <WeCockpitLogo size={40} tone="light" withTagline/>
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-sm font-bold uppercase tracking-wider text-slate-500">Stacked / Splash</h2>
        <div className="bg-gradient-to-br from-[#0F2744] to-slate-800 p-12 rounded-xl flex justify-center">
          <WeCockpitLogo variant="stacked" size={48} tone="light" withTagline/>
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-sm font-bold uppercase tracking-wider text-slate-500">Mark only — favicons / compact</h2>
        <div className="bg-white p-6 rounded-xl border flex flex-wrap gap-4 items-center">
          {[16, 24, 32, 48, 64, 96].map(s => (
            <div key={s} className="text-center">
              <WeCockpitLogo variant="mark" size={s} tone="dark"/>
              <div className="text-[10px] text-slate-400 mt-1">{s}px</div>
            </div>
          ))}
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-sm font-bold uppercase tracking-wider text-slate-500">Wordmark seul — footer</h2>
        <div className="bg-white p-6 rounded-xl border">
          <WeCockpitLogo variant="wordmark" size={20} tone="dark" withTagline/>
        </div>
      </section>
    </div>
  );
}
